import styled from 'styled-components';

export default styled.div`
    .textField {
        min-width: 250px;
        max-width: 250px;
    }
`;